//Built-in libraries

//Third party libraries

//Custom components

//Services

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export interface IDisclosureProps {
  step5: any;
}
export default function Disclosure({ step5 }: IDisclosureProps) {
  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal"
              >
                Disclosure
              </h2>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
            <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8">
              <div>
                <dt className="text-sm font-medium text-gray-500">
                  Name of Grantee Organization
                </dt>
                <dd className="mt-1 text-sm text-gray-900 capitalize">
                  {step5?.granteeName}
                </dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">
                  Authorized Representative
                </dt>
                <dd className="mt-1 text-sm text-gray-900 capitalize">
                  {step5?.authorizedRepresentative}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </section>
    </>
  );
}
